import React, { Fragment, useState } from "react";
import {
  PaymentContainer,
  HyperLink,
  TopCenter,
} from "../../PaymentHistory/Styles";
import { TableWrapper } from "../index";
import _ from "lodash";
import queryString from "query-string";
import CustomTable from "./CustomTable";
import CaseService from "../../../../services/CaseService";
import moment from "moment";
import {
  getErrorMessage,
  getFileFormat,
  getFileName,
} from "../../../../helpers/functions";
import { useSnackbar } from "notistack";
import labels from "../../../../helpers/labels.json";
import {
  ButtonWrapper,
  AcceptButton,
  DeclineButton,
  Footer,
  ButtonContainer,
  DangerBtn,
  StatusBadge,
} from "../Styles";
import useLoader from "../../../../hooks/useLoader";
import Preview from "./Preview";
import { PrimaryCTAButton } from "../../../common/Buttons";
import AlertDialog from "./AlertWrapper";
import theme from "../../../../assets/theme";
import { CommentSplitUp } from "./CommentSplitUp";
import GenerateNotice from "./GenerateNotice";
import { CustomInputField } from "../../../common/FormInputs";
import { makeStyles, Tooltip } from "@material-ui/core";
import { StyledSelectFormControl } from "../../../common/CustomSelect/styles";
import NoticeService from "../../../../services/NoticeService";
import Axios from "axios";
import {
  StyledAutocomplete,
  OptionContainer,
  OptionCheck,
  OptionContent,
  OptionEmail,
  OptionName,
} from "../../NoticeGeneration/component/CustomSelect";
import COLORS from "../../../../assets/Colors";

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: COLORS.PRIMARY_WHITE,
    boxShadow: "none",
    width: "77px",
    height: "30px",
    color: COLORS.BTN_GREEN,
    textTransform: "Capitalize",
    border: "solid 1px #00838c",
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 14,
  },
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  table: {
    backgroundColor: "transparent",
    border: "1px solid #e1e3ee",
    borderRadius: 7,
    "& .MuiTableCell-root": {
      borderBottom: 0,
    },
  },
  tableHead: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: COLORS.INPUT_LABEL,
    fontSize: 12,
  },
  tableBody: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: COLORS.COLOR_DARK,
    fontSize: 12,
  },
  listbox: {
    color: "#293461",
    fontFamily: "openSans-SemiBold, sans-serif",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    "& li[data-option-index]": {
      padding: "12px 16px !important",
      borderBottom: "1px solid #f3f4f6",
      transition: "all 0.2s ease",

      "&:hover": {
        backgroundColor: "#f0f9ff",
        paddingLeft: "20px !important",
      },
    },
  },
  noOptions: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#8294a5",
    padding: "16px",
    fontSize: "14px",
  },
  paper: {
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1) !important",
    borderRadius: "8px !important",
    border: "1px solid #e2e8f0 !important",
    width: "450px",
  },
}));

async function getMakerCheckerDetails(query = "") {
  try {
    const response = await CaseService.getMakerCheckerDetails(query);
    return { ...response };
  } catch (error) {
    throw error;
  }
}

const NoticeAudit = ({ auditor, id, MTRef, menuItems }) => {
  const [state, setState] = useState({});
  const placeholderText = "Search notice";
  const { enqueueSnackbar } = useSnackbar();
  const [modal, setModal] = useState({ state: false });
  const { setLoader } = useLoader();
  const [selectedId, setSelectedId] = useState([]);
  const [dialogData, setDialogData] = useState({});
  const [open, setOpen] = useState(false);
  const [paperModal, setPaperModal] = useState({ state: false });
  const classes = useStyles();

  async function makerChekerUpdateStatus(reasonText, checkerId, id, status) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: [id],
        checkStatus: status,
        checkerId: parseInt(checkerId),
        filter: "bulkNoticeUpload",
        comments: reasonText,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  async function handleChecker(id, checkerId) {
    try {
      setLoader({ state: true, message: "Regenerate notice..." });
      let payload = {
        id: id,
        checkerId: parseInt(checkerId),
      };
      const response = await NoticeService.bulkNoticeGenerate(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const error = getErrorMessage(err);
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }
  // useEffect(() => {
  //   if (auditor) {
  //     MTRef.current.onQueryChange(MTRef?.current?.state?.query);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auditor]);

  const fetchNotice = async (jobId) => {
    try {
      setLoader({ state: true, message: "fetching status..." });
      const response = await Axios.get(
        `https://mod.justact.co.in/get_notice/${jobId}`,
      );
      if (
        response?.data?.status === "failed" &&
        response?.data?.result_url === null
      ) {
        enqueueSnackbar("Please use the correct coded template", {
          variant: "error",
        });
      } else if (
        response?.data?.completed_rows > 0 &&
        response?.data?.result_url
      ) {
        await NoticeService.updateNoticeOutput({
          jobId: jobId,
          outputFile: response?.data?.result_url,
        });
        MTRef.current.onQueryChange(MTRef?.current?.state?.query);
      } else if (response?.data?.status === "running") {
        enqueueSnackbar(`${response?.data?.progress}% completed`, {
          variant: "info",
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoader({ state: false });
    }
  };

  const columns = [
    {
      field: "id",
      title: "Id",
      sorting: false,
      render: (rowData) => <TopCenter>{rowData?.id}</TopCenter>,
      headerStyle: {
        width: 60,
      },
      cellStyle: {
        width: 80,
      },
    },
    {
      field: "name",
      title: "Maker Name",
      sorting: false,
      render: (rowData) => rowData?.makerDetails?.name,
    },
    {
      field: "name",
      title: "Checker Name",
      sorting: false,
      render: (rowData) =>
        rowData?.checkerDetails?.name ? (
          rowData?.checkerDetails?.name
        ) : auditor === "maker" ? (
          rowData?.url ? (
            <StyledSelectFormControl
              style={{ width: "180px" }}
              className="mis-dashboard"
            >
              <StyledAutocomplete
                classes={{
                  listbox: classes.listbox,
                  noOptions: classes.noOptions,
                  paper: classes.paper,
                }}
                options={menuItems.filter((item) => item.value !== id)}
                getOptionLabel={(option) => `${option.name} (${option.email})`}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(event, newValue) => {
                  if (!newValue) return;

                  setOpen(true);
                  setDialogData({
                    primaryBtnText: "Cancel",
                    secondaryBtnText: "Submit",
                    notTextArea: false,
                    clickSecondarybtn: () =>
                      handleChecker(rowData?.id, newValue.value),
                    clickPrimaryBtn: () => setOpen(false),
                    onDialogClose: () => setOpen(false),
                    desc: `Please note once you add the checker, you cannot change.`,
                    heading: "Are you sure you want to add this checker ?",
                    status: true,
                    descriptionTextStyle: {
                      textAlign: "left",
                      fontFamily: theme.fonts.primaryFontSemiBold,
                    },
                  });
                }}
                renderOption={(option) => (
                  <OptionContainer>
                    <OptionContent>
                      <OptionName>{option.name}</OptionName>
                      <OptionEmail>{option.email}</OptionEmail>
                    </OptionContent>
                    <OptionCheck>✓</OptionCheck>
                  </OptionContainer>
                )}
                renderInput={(params) => (
                  <CustomInputField
                    {...params}
                    placeholder="Search checker"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </StyledSelectFormControl>
          ) : (
            <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
          )
        ) : rowData?.checkerDetails?.name ? (
          rowData?.checkerDetails?.name
        ) : (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ),
    },
    {
      field: "updated_at",
      title: labels["table.date"],
      sorting: false,
      render: (rowData) => (
        <>
          {moment(rowData?.updated_at, "YYYY-MM-DD HH:mm:ss")
            .add(5, "hours")
            .add(30, "minutes")
            .format("DD MMM YYYY, hh:mm A")}
        </>
      ),
      headerStyle: {
        width: 220,
      },
      cellStyle: {
        width: 230,
      },
    },
    {
      field: "id",
      title: "Preview",
      sorting: false,
      render: (rowData) =>
        rowData?.url ? (
          <Tooltip title={getFileName(rowData?.url)} placement="right">
            <HyperLink
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              onClick={() =>
                setModal({
                  state: true,
                  url: rowData?.url,
                  format: getFileFormat(rowData?.url),
                  pdf: rowData?.url.toLowerCase().endsWith(".pdf"),
                  checkStatus: rowData?.checkStatus === "checked",
                })
              }
            >
              {getFileName(rowData?.url)}
            </HyperLink>
          </Tooltip>
        ) : (
          <Tooltip
            title={`${rowData?.lotNo} - ${rowData?.templateCode}`}
            placement="right"
          >
            <HyperLink
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              onClick={() => fetchNotice(rowData?.id)}
            >
              {rowData?.lotNo} - {rowData?.templateCode}
            </HyperLink>
          </Tooltip>
        ),
    },
    {
      field: "checkStatus",
      title: "Status",
      sorting: false,
      render: (rowData) =>
        rowData?.checkStatus === "checked" ? (
          <StatusBadge status="Approved">Approved</StatusBadge>
        ) : rowData?.checkStatus === "rejected" ? (
          <StatusBadge status="Rejected">Rejected</StatusBadge>
        ) : (
          <StatusBadge status="Pending">Pending</StatusBadge>
        ),
    },
    {
      field: "",
      title: "Re Generate",
      sorting: false,
      hidden: auditor === "maker" ? false : true,
      render: (rowData) =>
        rowData?.checkerDetails?.name ? (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ) : rowData?.checkerId ? (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ) : rowData?.url ? (
          <HyperLink>
            <TopCenter
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() =>
                setPaperModal({
                  state: true,
                  metaData: rowData?.regeneratePayload,
                })
              }
            >
              Re Generate
            </TopCenter>
          </HyperLink>
        ) : (
          <TopCenter style={{ marginLeft: 15 }}>-</TopCenter>
        ),
    },
    {
      field: "actions",
      title: "Actions",
      sorting: false,
      hidden: auditor === "maker" ? true : false,
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) =>
        rowData?.checkerAcceptedAt ? (
          <ButtonWrapper>
            <TopCenter>Completed</TopCenter>
          </ButtonWrapper>
        ) : (
          <ButtonWrapper>
            <AcceptButton
              onClick={() =>
                makerChekerUpdateStatus(
                  "",
                  rowData?.checkerId,
                  rowData?.id,
                  "checked",
                )
              }
            >
              <img
                src={require("../../../../assets/images/checkBoxSelected.svg")}
                alt="accept"
              />
            </AcceptButton>
            <DeclineButton
              onClick={() => {
                setOpen(true);
                setDialogData({
                  primaryBtnText: "Cancel",
                  secondaryBtnText: "Submit",
                  clickSecondarybtn: (reasonText) =>
                    makerChekerUpdateStatus(
                      reasonText,
                      rowData?.checkerId,
                      rowData?.id,
                      "rejected",
                    ),
                  clickPrimaryBtn: () => setOpen(false),
                  onDialogClose: () => setOpen(false),
                  desc: `Please note once you reject the notice, you cannot continue approve again.`,
                  heading: "Do you really want to Reject this notice?",
                  status: true,
                  descriptionTextStyle: {
                    textAlign: "left",
                    fontFamily: theme.fonts.primaryFontSemiBold,
                  },
                });
              }}
            >
              <img
                src={require("../../../../assets/images/closeButton.svg")}
                alt="decline"
              />
            </DeclineButton>
          </ButtonWrapper>
        ),
    },
  ];

  const data = (query) =>
    new Promise((resolve) => {
      let params = {
        page: query.page + 1,
        perPage: 10,
      };
      if (query.search) {
        params.query = query.search;
      }
      if (query.orderBy?.field) {
        params.sort = query.orderBy.field;
        params.sortDirection = query.orderDirection;
      }
      let stringParams = "";
      if (!_.isEmpty(params)) {
        stringParams = `/${auditor}/${id}/bulkNoticeUpload?${queryString.stringify(
          params,
        )}`;
      }
      getMakerCheckerDetails(stringParams)
        .then(async (result) => {
          if (result) {
            resolve({
              data: result.data,
              page: result.page - 1,
              total: result.total,
            });
            setState(result);
          }
        })
        .catch((error) => {
          enqueueSnackbar(getErrorMessage(error), {
            variant: "error",
          });
          setState({ data: [], lastPage: 1, page: 1, perPage: 10, total: 0 });
          resolve({
            data: [],
            page: 0,
            total: 0,
          });
        });
    });

  async function handleCaseSelection(reasonText, status) {
    try {
      setLoader({ state: true, message: `split and upload...` });
      const payload = {
        id: selectedId,
        checkStatus: status,
        checkerId: parseInt(id),
        filter: "bulkNoticeUpload",
        comments: reasonText,
      };
      const response = await CaseService.updateMakerChekerStatus(payload);
      if (response?.message) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setSelectedId([]);
      setOpen(false);
      setDialogData({});
      MTRef.current.onQueryChange(MTRef?.current?.state?.query);
    }
  }

  const detailPanel = [
    {
      tooltip: "View detailed split up...",
      render: (rowData) => {
        return <CommentSplitUp data={rowData} />;
      },
    },
  ];

  return (
    <Fragment>
      <PaymentContainer className="CreateCase" style={{ overflow: "hidden" }}>
        <TableWrapper>
          <CustomTable
            selection={auditor === "maker" ? false : true}
            onSelectionChange={(selected) =>
              setSelectedId(
                selected
                  .filter(({ checkerAcceptedAt }) => !checkerAcceptedAt)
                  .map(({ id }) => id),
              )
            }
            hidePagination={state.lastPage === 1}
            pageSize={state?.data?.length ? state?.data?.length : 10}
            pluralTitle={"Notice"}
            singularTitle=""
            {...{
              columns,
              data,
              placeholderText,
              MTRef,
            }}
            detailPanel={auditor === "maker" ? detailPanel : ""}
            //noToolbar
            hideFilterBar
            state={state}
          />
          {selectedId?.length ? (
            <Footer>
              <ButtonContainer>
                <div className="button-row">
                  <DangerBtn
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => {
                      setOpen(true);
                      setDialogData({
                        primaryBtnText: "Cancel",
                        secondaryBtnText: "Submit",
                        clickSecondarybtn: (reasonText) =>
                          handleCaseSelection(reasonText, "rejected"),
                        clickPrimaryBtn: () => setOpen(false),
                        onDialogClose: () => setOpen(false),
                        desc: `Please note once you reject the notice, you cannot continue approve again.`,
                        heading: "Do you really want to reject this notice?",
                        status: true,
                        descriptionTextStyle: {
                          textAlign: "left",
                          fontFamily: theme.fonts.primaryFontSemiBold,
                        },
                      });
                    }}
                  >
                    Reject
                  </DangerBtn>

                  <PrimaryCTAButton
                    style={{
                      width: "216px",
                      marginLeft: "26px",
                      marginTop: 20,
                    }}
                    onClick={() => handleCaseSelection("", "checked")}
                  >
                    Approve
                  </PrimaryCTAButton>
                </div>
              </ButtonContainer>
            </Footer>
          ) : null}
        </TableWrapper>
      </PaymentContainer>
      {modal?.state && <Preview {...{ modal, setModal }} />}
      {paperModal?.state && (
        <GenerateNotice {...{ paperModal, setPaperModal }} />
      )}
      <AlertDialog
        isOpen={open}
        {...{ ...dialogData }}
        descriptionTextStyle={{
          textAlign: "left",
          fontFamily: theme.fonts.primaryFontSemiBold,
        }}
      />
    </Fragment>
  );
};

export default NoticeAudit;
